module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"street":"Rue","city":"Ville","zip-code":"Code postal","country":"Pays","errors":{"max_length":"50 Caractères maximum","required":"Champ requis"}},"en":{"street":"Street","city":"City","zip-code":"Zip code","country":"Country","errors":{"max_length":"50 characters max.","required":"Required field"}}}')
  delete Component.options._Ctor
}
